import client from '../GraphQlClient';
import BusinessEntity from './BusinessEntity';

/**
 * Helper class for BusinessEntityWithOrderNo.
 */
export class BusinessEntityWithOrderNoHelper
{
    /**
     * Move an entity to a new position.
     * 
     * @param entityName The name of the entity.
     * @param entity The entity to move.
     * @param targetEntity The target entity.
     * @param before If true, the entity will be moved before the target entity. If false, the entity will be moved after the target entity.
     * @returns True if the entity was moved, false if not.
     */
    static async moveTo(entityName: string, entity: BusinessEntity, targetEntity: BusinessEntity, before: boolean = true)
    {
        const { gql } = await import('@apollo/client');

        let query = `
            mutation Move${entityName}($id: Int!, $targetId: Int!, $before: Boolean) {
                move${entityName}(id: $id, targetId: $targetId, before: $before) {
                    success
                }
            }
        `;

        let variables = {
            id: entity.id,
            targetId: targetEntity.id,
            before: before
        };

        let { data } = await client.mutate({
            mutation: gql(query),
            variables: variables
        });
        console.log(data);

        return data['move' + entityName].success as boolean;
    }
}

export default BusinessEntityWithOrderNoHelper;